module.exports = __webpack_public_path__ + "static/media/icn_recording_60x60.bb22c436.svg";